import { useEffect, useState } from "react";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { Alert } from "../../../../theme/Component/Alert";

interface ButtonsLabel {
    labelNext?: string;
    labelDiscard?: string;
    labelReturn?: string;
}

export interface StepWizard {
    keyID: string;
    name: string;
    onEvent: Function;
    children: any;
    validButton: boolean;
    canReturn: boolean;
    canDiscard?: boolean;
    labelList?: ButtonsLabel;
}

interface Props {
    title: string;
    listStep: StepWizard[];
    onStep?: Function;
}
export const Wizard = ({ title, listStep, onStep }: Props) => {

    const [index, setIndex] = useState<number>(0);
    const [current, setCurrent] = useState<StepWizard>(undefined);

    useEffect(() => {
        getStep(index);
    }, [listStep])

    useEffect(() => {
        getStep(index);

    }, [index])

    const next = () => {
        //console.log("avanzar");
        setIndex(prev => prev + 1);
    }
    const prev = () => {
        //console.log("avanzar");
        setIndex(prev => prev - 1);
    }

    const discard = () => {
        //console.log("descartar");
        setIndex(0)
    }

    const getStep = (i: number) => {
        if (i < listStep.length) {
            setCurrent(listStep[i]);
            if (onStep)
                onStep(listStep[i].keyID);
        }
    }

    return (
        <div className="row">
            <div className="col">
                {current ?
                    <div className="card">
                        <div className="card-body">
                            <div className="card-title">
                                {current.name}
                                <hr />
                            </div>
                            {current.children}
                        </div>
                        <div className="card-footer d-flex justify-content-between align-items-center">

                            <div>
                                {index > 0 && current.canReturn &&
                                    <BasicButton icon="ri-skip-back-line" eventClick={prev} >
                                        {current.labelList ? current.labelList.labelReturn : "Atras"}
                                    </BasicButton>
                                }

                                {index > 0 && current.canDiscard &&
                                    <BasicButton icon="ri-delete-bin-line" clase="danger" eventClick={discard} >
                                        {current.labelList ? current.labelList.labelDiscard : "Descartar"}
                                    </BasicButton>
                                }
                            </div>

                            <div>
                                {index < listStep.length &&
                                    <BasicButton icon="ri-skip-forward-line" disable={!current.validButton} eventClick={() => {
                                        if (current.onEvent) {
                                            current.onEvent();
                                        }
                                        next();
                                    }}
                                    >
                                        {current.labelList ? current.labelList.labelNext : "Siguiente"}
                                    </BasicButton>
                                }
                            </div>

                        </div>
                    </div>
                    :
                    <Alert clase="warning">
                        <strong>Sin elementos</strong>
                    </Alert>
                }
            </div>
        </div>
    )
}